import { render, staticRenderFns } from "./MultiselectTags.vue?vue&type=template&id=081492a8"
import script from "./MultiselectTags.vue?vue&type=script&lang=js"
export * from "./MultiselectTags.vue?vue&type=script&lang=js"
import style0 from "./MultiselectTags.vue?vue&type=style&index=0&id=081492a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports